<template>
    <div>
        <h1 class="h5">Schrijf je in!</h1>

        <div class="formfield formfield--inputlist">
            <div class="h3">
                Heb je al een IJSTIJD! account?
            </div>

            <label class="formfield__choice">
                <input 
                    type="radio" 
                    name="hasAlreadyAccount" 
                    value="0" 
                    v-model="hasAlreadyAccount">
                <span>Nee</span>
            </label>

            <label class="formfield__choice">
                <input 
                    type="radio" 
                    name="hasAlreadyAccount" 
                    value="1" 
                    v-model="hasAlreadyAccount">
                <span>Ja</span>
            </label>
        </div>

        <hr class="form-line">

        <Signup v-if="hasAlreadyAccount === '0'" />
        <Login v-else-if="hasAlreadyAccount === '1'" />
    </div>
</template>

<script>
import Signup from './register/Signup.vue';
import Login from './register/Login.vue';

export default {
    components: {
        Signup,
        Login,
    },
    data() {
        return {
            hasAlreadyAccount: '0',
        };
    },
};
</script>
